
export enum AuditLogEntryType {
  AdminOrderPaymentMethodChanged = 'AdminOrderPaymentMethodChanged',
  OfflineEventTicketOrderAborted = 'OfflineEventTicketOrderAborted',
  OfflineEventTicketOrderCompleted = 'OfflineEventTicketOrderCompleted',
  OfflineEventTicketOrderCreated = 'OfflineEventTicketOrderCreated',
  OfflineEventTicketOrderModified = 'OfflineEventTicketOrderModified',
  OfflineEventTicketOrderPaymentMethodChanged = 'OfflineEventTicketOrderPaymentMethodChanged',
  OnlineEventPassOrderCreated = 'OnlineEventPassOrderCreated',
  OnlineEventTicketOrderAborted = 'OnlineEventTicketOrderAborted',
  OnlineEventTicketOrderCanceled = 'OnlineEventTicketOrderCanceled',
  OnlineEventTicketOrderCompleted = 'OnlineEventTicketOrderCompleted',
  OnlineEventTicketOrderCreated = 'OnlineEventTicketOrderCreated',
  OnlineEventTicketOrderRefunded = 'OnlineEventTicketOrderRefunded',
  OnlineProductOrderAborted = 'OnlineProductOrderAborted',
  OnlineProductOrderCanceled = 'OnlineProductOrderCanceled',
  OnlineProductOrderCompleted = 'OnlineProductOrderCompleted',
  OnlineProductOrderCreated = 'OnlineProductOrderCreated',
  OnlineProductOrderRefunded = 'OnlineProductOrderRefunded',
  EventOpenAccessPassCreated = 'EventOpenAccessPassCreated',
  EventOpenAccessPassModifiedEvents = 'EventOpenAccessPassModifiedEvents',
  EventOpenAccessPassModifiedMaxCount = 'EventOpenAccessPassModifiedMaxCount',
  EventOpenAccessPassRefunded = 'EventOpenAccessPassRefunded',
  SeatedEventOpenAccessPassSwap = 'SeatedEventOpenAccessPassSwap',
  SeatedEventOpenAccessPassMoved = 'SeatedEventOpenAccessPassMoved',
  GenericSeatedEventTicketSwap = 'GenericSeatedEventTicketSwap',
  SeatedOfflineEventTicketSwap = 'SeatedOfflineEventTicketSwap',
  SeatedOnlineEventTicketSwap = 'SeatedOnlineEventTicketSwap',
  GenericOrderCreated = 'GenericOrderCreated',
  GenericOrderCompleted = 'GenericOrderCompleted',
  GenericOrderAborted = 'GenericOrderAborted',
  GenericOrderRefunded = 'GenericOrderRefunded',
  GenericOrderCanceled = 'GenericOrderCanceled',
}
